export default __webpack_public_path__ + "static/Plots0000-ba0ec9b5f9ace7633b7bf584b0cc6e79.jpg";